export const HOMEAWAY_CHECKPOINT_LABEL_BASE_KEY =
  'calendar_properties_channels.channels.vrbo.checkpoints.names';

export interface IHomeawayCheckpointItem {
  name: string;
  label: string;
  route?: string;
}

const RELATIVE_ROUTES: Record<string, string> = {
  HasImages: 'properties.details.photos',
  HasRates: 'properties.pricing.base',
  HasPropertyHeadline: 'properties.details.homeaway',
  HasPropertyDescription: 'properties.details.homeaway',
  HasCancellationPolicy: 'properties.details.homeaway',
  HasPropertyDetails: 'properties.details.basics',
  HasPropertyType: 'properties.details.basics',
  HasBathroom: 'properties.details.basics',
  HasMaxOccupancy: 'properties.details.basics',
  HasCheckInCheckOut: 'properties.details.basics',
  HasHouseRules: 'properties.details.basics',
  HasRegistrationNumber: 'properties.details.basics',
  HasLocation: 'properties.details.address',
  HasValidatedAddress: 'properties.details.address',
  HasGeoCode: 'properties.details.address',
};

const ABSOLUTE_ROUTES: Record<string, string> = {
  HasAcceptedPaymentForm: 'connect.stripe',
};

export function homeawayCheckpointRoute(
  name: string,
  baseRoute: string,
): string | undefined {
  const absolute = ABSOLUTE_ROUTES[name];

  if (absolute) {
    return absolute;
  }

  const relative = RELATIVE_ROUTES[name];

  return relative ? `${baseRoute}.${relative}` : undefined;
}

export function uniqueHomeawayCheckpointItems(
  items: IHomeawayCheckpointItem[],
): IHomeawayCheckpointItem[] {
  const seenLabels = new Set<string>();

  return items.filter(({ label }) => {
    if (seenLabels.has(label)) {
      return false;
    }

    seenLabels.add(label);

    return true;
  });
}
